import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { useEntity } from 'components';
import { CampaignDetails } from 'modules/campaign/campaign/types';
import { CommentDialogToggle } from 'modules/comments';
import invariant from 'tiny-invariant';
import { CampaignMenu } from './CampaingMenu';
import { UserAvatar } from 'components/UserAvatar';
import { PeriodWidget } from 'components/PeriodWidget';
import { Header } from 'components/Header';
import { CampaignStateTag } from '../status/CampaignStateTag';
import { Icon } from '@ff-it/ui';

export function CampaignHeader(): ReactElement | null {
  const location = useParams();

  const plan = 'block_id' in location;

  const { item, mutate } = useEntity<CampaignDetails>();
  const {
    date_from,
    date_to,
    title,
    number,
    sums: { state },
    manager,
    brand,
  } = item;

  if (plan) {
    return null;
  }

  return (
    <Header
      heading={
        <>
          <Icon icon="map" /> {title}
        </>
      }
      menu={plan ? undefined : <CampaignMenu task_list={item.task_list} />}
      attributes={
        <Header.AttributeContainer>
          <Header.Attribute label="for">{item.client.internal_name}</Header.Attribute>
          {item.payer.id !== item.client.id && (
            <Header.Attribute label="payer">{item.payer.internal_name}</Header.Attribute>
          )}
          {brand && <Header.Attribute label="brand">{brand.title}</Header.Attribute>}
          <Header.Attribute>{number}</Header.Attribute>
          <Header.Attribute>
            <CampaignStateTag state={state} size="sm" />
          </Header.Attribute>
          <Header.Attribute>
            <CommentDialogToggle
              topic={item.topic}
              onTopicUpdate={(topic) =>
                mutate((data) => {
                  invariant(data);
                  return { ...data, topic };
                })
              }
            />
          </Header.Attribute>
        </Header.AttributeContainer>
      }
      metaAttributes={
        <Header.AttributeContainer>
          <Header.Attribute>
            Manager: <UserAvatar user={manager} size="xxs" />
          </Header.Attribute>
          <Header.Attribute>
            <PeriodWidget date_from={date_from} date_to={date_to} distance />
          </Header.Attribute>
        </Header.AttributeContainer>
      }
    />
  );
}
